import { render } from "./ThemeSettings.vue?vue&type=template&id=2aea49a4"
import script from "./ThemeSettings.vue?vue&type=script&lang=js"
export * from "./ThemeSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__